/* eslint-disable no-undef */
/* eslint-disable vars-on-top */
import { Auth } from 'aws-amplify'
import { submitToApi as submitToApiLib } from '@wellbeingxltd/fe-lib/api/dist'
import { isRedirectingRoute } from '@wellbeingxltd/fe-lib/constants'

// Setup environment
let __ENV__

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' || window.location.origin.match(/https?:\/\/dev-/)) __ENV__ = 'DEV'
if (process.env.NODE_ENV === 'production' && window.location.origin.match(/https?:\/\/demo-/)) __ENV__ = 'DEMO'
if (process.env.NODE_ENV === 'production' && window.location.origin.match(/https?:\/\/stg-/)) __ENV__ = 'STG'
if (process.env.NODE_ENV === 'production' && window.location.origin.match(/https?:\/\/(prd-|supplier.)/)) __ENV__ = 'PRD'

// __ENV__ = 'DEV'
// __ENV__ = 'DEMO'
// __ENV__ = 'STG'
// __ENV__ = 'PRD'

export { __ENV__ }

console.log(`%c env: ${__ENV__}`, 'color: #6f6')

// For full list of props, see https://github.com/wellbeingxltd/fe-lib/blob/main/api/src/index.js
export function submitToApi(props) {
    return Auth.currentCredentials().then(creds => {
        return Auth.currentAuthenticatedUser()
            .then(cognitoUser => {
                return Promise.resolve(submitToApiLib({ cognitoUser, creds, platform: 'supplier', ...props }))
            })
            .catch(error => {
                return Promise.reject(error)
            })
    })
}

export function amplifyAuthentication(credentials) {
    return Auth.signIn({
        username: credentials.username,
        password: credentials.password,
    })
}

export function amplifySignup(params) {
    return Auth.signUp(params)
}

export function confirmSignUp(code, email) {
    return Auth.confirmSignUp(email, code)
}

export const forgotPassword = async (email, successCallback = () => {}, errorCallback) => {
    try {
        await Auth.forgotPassword(email)
        console.log('[API] forgotPassword success ')
        successCallback()
    } catch (error) {
        console.log('[API] forgotPassword error ', error)

        /*
            During password reset FROM LOGIN PAGE If the email does not exist
            Continue to confirmation screen as if nothing is wrong

            `errorCallback` passed only for Settings page to handle errors with better UX
        */
        errorCallback ? errorCallback(error) : successCallback()
    }
}

export function forgotPasswordSubmit(email, code, password, successCallback, errorCallback) {
    Auth.forgotPasswordSubmit(email, code, password)
        .then(data => {
            successCallback()
        })
        .catch(err => {
            errorCallback(err)
        })
}

export function isAuthenticated(repoKey) {
    // Check whether the current time is past the
    // Access Token's expiry time
    const expires_at = localStorage.getItem('willExpire')
    const cognitoUser = JSON.parse(localStorage.getItem('cognitoUser'))
    const parsedExpires_at = JSON.parse(expires_at)
    const route = window.location.pathname
    const checkRoute = isRedirectingRoute(route, repoKey)
    const wasRedirected = !!sessionStorage.getItem('wasRedirected')
    if (checkRoute && !cognitoUser && !wasRedirected) {
        sessionStorage.setItem('redirectAfterLoginByLink', route)
    }
    if (!localStorage.getItem('confirmSignup') && (!cognitoUser || new Date().getTime() > parsedExpires_at)) {
        localStorage.clear()
        return false
    }
    return new Date().getTime() < parsedExpires_at
}
